import { WidgetQuickSurveyContent } from 'jamespot-user-api';
import React, { useEffect } from 'react';

import { useIntl } from 'react-intl';

import { JRCIconButton, JRCTypography } from '../../..';
import { FormItemContainer, Row } from './JRCWidgetQuickSurveyEditor.styles';

export const JRCWidgetQuickSurveyEditorAddEntry = ({
    content,
    handleNewItem,
}: {
    content: WidgetQuickSurveyContent;
    handleNewItem: () => void;
}) => {
    const intl = useIntl();

    useEffect(() => {
        if (content.arr?.length === 0) {
            handleNewItem();
        }
    }, [content.arr, handleNewItem]);

    return (
        <FormItemContainer>
            <Row onClick={handleNewItem}>
                <JRCIconButton icon="icon-plus" title={intl.formatMessage({ id: 'BUTTON_Title_Add_New_Survey' })} />
                <JRCTypography size="l">{intl.formatMessage({ id: 'FIELDS_Add_Option' })}</JRCTypography>
            </Row>
        </FormItemContainer>
    );
};
